import socket, { invokeRPC } from './socket.js'

export function getTables() {
  return invokeRPC('filter', 'getTables')
}

export function getColumns(tableName) {
  return invokeRPC('filter', 'getColumns', { table_name: tableName })
}

export function createFilter(data) {
  return invokeRPC('filter', 'createFilter', data)
}

export function deleteFilter(filtersId) {
  return invokeRPC('filter', 'deleteFilter', { filters_id: filtersId })
}

export function getFilter(filtersId) {
  return invokeRPC('filter', 'getFilter', { filters_id: filtersId })
}

export function getFilters(projectId) {
  return invokeRPC('filter', 'getFilters', { project_id: projectId })
}

export function getUsableFilters(projectId) {
  return invokeRPC('filter', 'getUsableFilters', { project_id: projectId })
}

export function getFilteredFilter(projectId, tableName, columnName, customSort, selections) {
  return invokeRPC('filter', 'getFilteredFilter', {
    project_id: projectId,
    table_name: tableName,
    column_name: columnName,
    custom_sort: customSort,
    selections
  })
}

export function getUpdatedSelections(projectId, tableName, selections) {
  return invokeRPC('filter', 'getUpdatedSelections', {
    project_id: projectId,
    table_name: tableName,
    selections
  })
}

export function updateFilter(data) {
  return invokeRPC('filter', 'updateFilter', data)
}

export function orderFilters(order) {
  return invokeRPC('filter', 'orderFilters', { order })
}

export function checkFilter(filtersId) {
  return invokeRPC('filter', 'checkFilter', { filters_id: filtersId })
}

export function deleteFilterColumn(filterId) {
  return invokeRPC('filter', 'deleteFilterColumn', { filter_id: filterId })
}

export function updateRestrictedFilterValues(user_id, filter_id, column_id, to_add, to_remove) {
  return invokeRPC('filter', 'updateRestrictedFilterValues', {
    user_id,
    filter_id,
    column_id,
    to_add,
    to_remove
  })
}

export function getRestrictedFilterValues(user_id) {
  return invokeRPC('filter', 'getRestrictedFilterValues', { user_id })
}
